module.exports = __webpack_public_path__ + "static/img/cloud-bg-min.0b4c761.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/cloud-bg-min.png
// module id = 652
// module chunks = 64